export function buildQueryString(params: Record<string, unknown>) {
  const query = new URLSearchParams();

  const appendParam = (key: string, value: unknown) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => query.append(`${key}[]`, String(v)));
    } else {
      query.append(key, String(value));
    }
  };

  Object.entries(params).forEach(([k, v]) => appendParam(k, v));
  return query.toString();
}
